// // components/TimeSeriesChart.jsx
import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { processTimeSeriesData } from "../services/dataProcessing";

// const TimeSeriesChart = ({ data, location, variable }) => {
//   const chartRef = useRef();
//   console.log("Received data in TimeSeriesChart:", data);

//   useEffect(() => {
//     if (
//       !data ||
//       !data.variables ||
//       !data.variables[variable] ||
//       !data.variables.time ||
//       !data.variables.latitude ||
//       !data.variables.longitude ||
//       !location
//     ) {
//       console.warn("Missing required data or location.");
//       return;
//     }

//     const transformedData = {
//       data: {
//         [variable]: data.variables[variable].data,
//       },
//       coords: {
//         time: data.variables.time.data,
//         latitude: data.variables.latitude.data,
//         longitude: data.variables.longitude.data,
//       },
//     };

//     const timeSeriesData = processTimeSeriesData(
//       transformedData,
//       location,
//       variable
//     );

//     if (!timeSeriesData.length) return;

//     const width = 800;
//     const height = 400;
//     const margin = { top: 20, right: 30, bottom: 50, left: 60 };

//     d3.select(chartRef.current).selectAll("*").remove();

//     const svg = d3
//       .select(chartRef.current)
//       .append("svg")
//       .attr("width", width)
//       .attr("height", height);

//     const chart = svg
//       .append("g")
//       .attr("transform", `translate(${margin.left},${margin.top})`);

//     const xScale = d3
//       .scaleTime()
//       .domain(d3.extent(timeSeriesData, (d) => d.date))
//       .range([0, width - margin.left - margin.right]);

//     const yScale = d3
//       .scaleLinear()
//       .domain([0, d3.max(timeSeriesData, (d) => d.value) || 1])
//       .range([height - margin.top - margin.bottom, 0]);

//     const line = d3
//       .line()
//       .x((d) => xScale(d.date))
//       .y((d) => yScale(d.value));

//     chart
//       .append("g")
//       .attr("transform", `translate(0,${height - margin.top - margin.bottom})`)
//       .call(d3.axisBottom(xScale).ticks(5));

//     chart.append("g").call(d3.axisLeft(yScale));

//     chart
//       .append("path")
//       .datum(timeSeriesData)
//       .attr("fill", "none")
//       .attr("stroke", "steelblue")
//       .attr("stroke-width", 2)
//       .attr("d", line);

//     chart
//       .selectAll(".point")
//       .data(timeSeriesData)
//       .enter()
//       .append("circle")
//       .attr("class", "point")
//       .attr("cx", (d) => xScale(d.date))
//       .attr("cy", (d) => yScale(d.value))
//       .attr("r", 3)
//       .attr("fill", "steelblue");

//     svg
//       .append("text")
//       .attr("x", width / 2)
//       .attr("y", height - 5)
//       .attr("text-anchor", "middle")
//       .text("Date");

//     svg
//       .append("text")
//       .attr("transform", "rotate(-90)")
//       .attr("y", 15)
//       .attr("x", -height / 2)
//       .attr("text-anchor", "middle")
//       .text(`${variable}`);

//     svg
//       .append("text")
//       .attr("x", width / 2)
//       .attr("y", 15)
//       .attr("text-anchor", "middle")
//       .style("font-size", "16px")
//       .text(
//         `Time Series of ${variable} at (${location.lat.toFixed(
//           2
//         )}°, ${location.lon.toFixed(2)}°)`
//       );
//   }, [data, location, variable]);

//   return <div ref={chartRef} />;
// };

// export default TimeSeriesChart;
// ✅ Updated TimeSeriesChart.jsx with export and analysis

import html2canvas from "html2canvas";

const TimeSeriesChart = ({ data, location, variable }) => {
  const chartRef = useRef();

  useEffect(() => {
    if (
      !data ||
      !data.variables ||
      !data.variables[variable] ||
      !data.variables.time ||
      !data.variables.latitude ||
      !data.variables.longitude ||
      !location
    ) {
      return;
    }

    const transformedData = {
      data: {
        [variable]: data.variables[variable].data,
      },
      coords: {
        time: data.variables.time.data,
        latitude: data.variables.latitude.data,
        longitude: data.variables.longitude.data,
      },
    };

    const timeSeriesData = processTimeSeriesData(
      transformedData,
      location,
      variable
    );
    if (!timeSeriesData.length) return;

    const width = 800;
    const height = 400;
    const margin = { top: 40, right: 30, bottom: 50, left: 60 };

    d3.select(chartRef.current).selectAll("*").remove();
    const svg = d3
      .select(chartRef.current)
      .append("svg")
      .attr("width", width)
      .attr("height", height);

    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const xScale = d3
      .scaleTime()
      .domain(d3.extent(timeSeriesData, (d) => d.date))
      .range([0, width - margin.left - margin.right]);

    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(timeSeriesData, (d) => d.value) || 1])
      .range([height - margin.top - margin.bottom, 0]);

    const line = d3
      .line()
      .x((d) => xScale(d.date))
      .y((d) => yScale(d.value));

    chart
      .append("g")
      .attr("transform", `translate(0,${height - margin.top - margin.bottom})`)
      .call(d3.axisBottom(xScale).ticks(5));

    chart.append("g").call(d3.axisLeft(yScale));

    chart
      .append("path")
      .datum(timeSeriesData)
      .attr("fill", "none")
      .attr("stroke", "steelblue")
      .attr("stroke-width", 2)
      .attr("d", line);

    chart
      .selectAll(".point")
      .data(timeSeriesData)
      .enter()
      .append("circle")
      .attr("class", "point")
      .attr("cx", (d) => xScale(d.date))
      .attr("cy", (d) => yScale(d.value))
      .attr("r", 3)
      .attr("fill", "steelblue");

    // Markers for min and max
    const min = d3.min(timeSeriesData, (d) => d.value);
    const max = d3.max(timeSeriesData, (d) => d.value);
    chart
      .append("text")
      .attr("x", 10)
      .attr("y", -10)
      .text(`Min: ${min.toFixed(2)}, Max: ${max.toFixed(2)}`);

    // Labels
    svg
      .append("text")
      .attr("x", width / 2)
      .attr("y", height - 5)
      .attr("text-anchor", "middle")
      .text("Date");

    svg
      .append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 15)
      .attr("x", -height / 2)
      .attr("text-anchor", "middle")
      .text(`${variable}`);

    svg
      .append("text")
      .attr("x", width / 2)
      .attr("y", 20)
      .attr("text-anchor", "middle")
      .style("font-size", "16px")
      .text(
        `Time Series of ${variable} at (${location.lat.toFixed(
          2
        )}°, ${location.lon.toFixed(2)}°)`
      );
  }, [data, location, variable]);

  // === Export Functions ===
  const exportChartAsImage = async () => {
    const node = chartRef.current;
    const canvas = await html2canvas(node);
    const link = document.createElement("a");
    link.download = `${variable}_chart.png`;
    link.href = canvas.toDataURL();
    link.click();
  };

  const exportAsCSV = () => {
    const transformedData = processTimeSeriesData(
      {
        data: { [variable]: data.variables[variable].data },
        coords: {
          time: data.variables.time.data,
          latitude: data.variables.latitude.data,
          longitude: data.variables.longitude.data,
        },
      },
      location,
      variable
    );

    const rows = transformedData.map(
      (d) => `${d.date.toISOString()},${d.value}`
    );
    const blob = new Blob(["Date,Value\n" + rows.join("\n")], {
      type: "text/csv",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${variable}_data.csv`;
    link.click();
  };

  return (
    <div>
      <div style={{ textAlign: "right", marginBottom: "10px" }}>
        <button onClick={exportChartAsImage}>📷 Export as Image</button>
        <button onClick={exportAsCSV} style={{ marginLeft: "10px" }}>
          📄 Export as CSV
        </button>
      </div>
      <div ref={chartRef} />
    </div>
  );
};

export default TimeSeriesChart;
